import React from 'react';
import TeamSubmissionDropdown from './teamSubmissionDropdown';
import LoadFromLastRoundButton from './loadFromLastRoundButton';
import DdhpError from '../utilities/ddhpError';
import Errors from './errors';
import Stats from './stats';
import styles from './teamSubmission.module.scss';

export default class TeamSubmission extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            season:{nextUncompletedRound:{}}, 
            club:{contracts:[]}, 
            team:{},
            stats:{},
            result:{},
            errors:[]
        };
        this.getSeasonDetail = this.getSeasonDetail.bind(this);
        this.submit = this.submit.bind(this);
        this.validate = this.validate.bind(this);
        this.backToOldPage = this.backToOldPage.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
        this.getSelected = this.getSelected.bind(this);
    }
    
    async componentDidMount(){
        const parameters = this.getParametersFromUri();
        const season = await this.getSeasonDetail(parameters.season);
        const nextRound = season.nextUncompletedRound;
        const club = await this.getClubDetail(parameters.club, nextRound);
        await this.getTeam(club, nextRound);
    }

    backToOldPage(){
        document.cookie = `optOutBetaTeamSubmission=true; expires=${new Date(Date.now + (3*24*60*60*1000))}`;
        document.location.reload();
    }

    async getSeasonDetail(season){
        const seasonResult = await fetch(`/api/seasons/${season}`)
            .then(f => f.json());
        this.setState({
            season:{
                nextUncompletedRound:seasonResult.nextUncompletedRound,
                year:season
            }
        });
        return seasonResult;
    }

    async getClubDetail(club, round){
        const clubResult = await fetch(`/api/clubs/${club}/${round.year}/${round.roundNumber}`)
            .then(f => f.json());
        clubResult.contracts = clubResult.contracts.sort((a,b) => a.player.lastName > b.player.lastName);
        this.setState({club: clubResult});
        return clubResult;
    }

    async getTeam(club, round){
        const team = await fetch(`/api/seasons/${round.year}/teams/${round.roundNumber}/${club.clubId}`)
            .then(f => f.json());
        this.setState({team: team});
        
    }

    getParametersFromUri(){
        const path = window.location.pathname;
        const seasonRegex = /\/clubs\/(?<club>[a-zA-Z0-9]+)\/(?<season>\d+)/i;
        const match = path.match(seasonRegex).groups;
        return {
            season: match.season,
            club: match.club
        };
    }

    async submit(event){
        event.preventDefault();
        if (!this.validate()){
            return;
        }

        const round = this.state.season.nextUncompletedRound;
        var result = await fetch(`/api/seasons/${round.year}/teams/${round.roundNumber}/${this.state.club.clubId}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(this.state.team)
            });
        if (result.status === 200){
            this.setState({result:{success:true, errors:[]}});
        } else {
            this.setState(
                {
                    errors:['Failed. Try again.']
                });
        }
    }

    validate(){
        var playerIds = [];
        for (const playerList in this.state.team){
            playerIds = playerIds.concat(this.state.team[playerList]);
        }

        const playerCounts = playerIds.reduce((acc, curr) => {
            if (!(curr in acc)){
                acc[curr] = 0;
            }

            acc[curr] = acc[curr]+1;
            return acc;
        }, {});
        
        const errors = [];
        var success = true;
        for (var player in playerCounts){
            if (playerCounts[player] > 1){
                success = false;
                var match = this.state.club.contracts.filter(c => c.contract.id === parseInt(player))[0];
                errors.push(DdhpError.DuplicatePlayer(match, playerCounts[player]));
                
            }
        }
        this.setState({
            errors:
                errors
        });
        return success;
    }

    selectionChanged(position, index){
        const that = this;
        return function(event){
            const team = that.state.team;
            team[position] = team[position] || [];
            team[position][index] = parseInt(event.target.value);
            that.setState({team:team});
            that.validate();
        }
    }

    getSelected(position, index){
        const possibles = this.state.team[position];
        if (!possibles || possibles.length < index) {
            return '';
        }

        return possibles[index];
    }

    render(){
        var success = (<span></span>);
        if (this.state.result.success){
            success = (<span className={styles.success}>Saved</span>);
        }

        return (
            <div data-test='teamSubmission'>
                <h1 data-test='title'>{this.state.club.clubName} {this.state.season.nextUncompletedRound.year} {this.state.season.nextUncompletedRound.roundNumber}</h1>
                <button className={styles.betaOptoutLink} onClick={this.backToOldPage}>Take me back to the old page!</button>
                <div className={styles.teamSubmissionContainer}>
                    <form className={styles.grid}>
                        <LoadFromLastRoundButton Round={this.state.season.nextUncompletedRound} OnActivate={(round) => this.getTeam(this.state.club, round)} />
                        <fieldset name="forwards" className={styles.forwards}>
                            <legend>Forwards</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('f', 0)} Selected={this.getSelected('f',0)} Team={this.state.team} Errors={this.state.errors} />
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('f', 1)} Selected={this.getSelected('f',1)} Team={this.state.team} Errors={this.state.errors} />
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('f', 2)} Selected={this.getSelected('f',2)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <fieldset className={styles.midfielders}>
                            <legend>Midfielders</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('m', 0)} Selected={this.getSelected('m',0)} Team={this.state.team} Errors={this.state.errors} />
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('m', 1)} Selected={this.getSelected('m',1)} Team={this.state.team} Errors={this.state.errors} />
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('m', 2)} Selected={this.getSelected('m',2)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <fieldset className={styles.ruck}>
                            <legend>Ruck</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('r', 0)} Selected={this.getSelected('r',0)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <fieldset className={styles.tackle}>
                            <legend>Tackle</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('t', 0)} Selected={this.getSelected('t',0)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <fieldset className={styles.interchange}>
                            <legend>Bench</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('i', 0)} Selected={this.getSelected('i',0)} Team={this.state.team} Errors={this.state.errors} />
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('i', 1)} Selected={this.getSelected('i',1)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <fieldset className={styles.emergency}>
                            <legend>Emergency</legend>
                            <TeamSubmissionDropdown ContractPlayers={this.state.club.contracts} OnChange={this.selectionChanged('e', 0)} Selected={this.getSelected('e',0)} Team={this.state.team} Errors={this.state.errors} />
                        </fieldset>
                        <button onClick={this.submit}>Submit</button> {success} <Errors Errors={this.state.errors} />
                    </form>
                    <Stats ClubName={this.state.club.clubName} Season={this.state.season.year} Team={this.state.team} />
                </div>
            </div>
        );
    }
}